import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Collapse, Theme, Typography } from '@mui/material'
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { makeStyles } from '@mui/styles'

import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import AlertComponent from '@professocial/professocialFormComponents/FormComponents/AlertComponent'
import TextFieldComponent from '@professocial/professocialFormComponents/FormComponents/TextFieldComponent'

type Props = {
  maxLength?: number
  maxRows: number
  label: string
  text: string | undefined
  templateText: string
  updateText?: (desc: string | undefined) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  textarea: {
    '& textarea': {
      height: 'auto !important',
    },
  },
  button: {
    textTransform: 'inherit',
    fontWeight: '700',
  },
}))

const UserFacebookTemplateTextarea: React.FC<Props> = ({ maxLength, maxRows, label, templateText, updateText, text }) => {
  const [count, setCount] = useState(0)
  const [open, setOpen] = useState(false)
  const [onText, setOnText] = useState(false)
  const [inputValue, setInputValue] = useState<string | undefined>(undefined)

  const { t } = useTranslation()
  const classes = useStyles()

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = event.target.value
    setInputValue(value)
    value && setCount(value.length)
    setOnText(false)
  }

  const handleOpen = () => {
    setOpen(false)
  }

  useEffect(() => {
    onText && setInputValue(templateText)
    onText && setCount(templateText.length)
  }, [onText])

  useEffect(() => {
    updateText && updateText(inputValue)
  }, [inputValue])

  useEffect(() => {
    text && setInputValue(text)
  }, [text])

  return (
    <Box sx={{ textAlign: 'right', width: '100%' }}>
      <ButtonComponent
        onClick={() => {
          if (!open) {
            setOpen(true)
          } else {
            setOnText(true)
            setOpen(false)
          }
        }}
        className={classes.button}
        variant='text'
        color='info'
        text={open ? t('facebookSettingsCommon:takeTemplate') : t('facebookSettingsCommon:template')}
        startIcon={open ? <PlaylistAddCheckOutlinedIcon /> : <ContentCopyIcon />}
      />
      <Box textAlign='left'>
        <Collapse in={open}>
          <AlertComponent
            severity='info'
            setOpen={handleOpen}
          >
            {templateText}
          </AlertComponent>
        </Collapse>
      </Box>
      <TextFieldComponent
        inputProps={{ maxLength: maxLength, readOnly: false }}
        onChange={handleChange}
        className={classes.textarea}
        label={label}
        rows={maxRows}
        value={inputValue}
        multiline
        fullWidth
      />
      {maxLength && <Typography variant='body2'>{count}/{maxLength}</Typography>}
    </Box>
  )
}

export default UserFacebookTemplateTextarea
